import isEqual from 'lodash/isEqual';

/** shouldComponentUpdate
 * helper function that validates whether Cell's shouldComponentUpdate should run
 */
export const shouldComponentUpdate = ({ checked, rowData, value }, props) =>
  checked !== props.checked || !isEqual(props.rowData, rowData) || !isEqual(props.value, value);
